import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

interface Props {
  isApplyValid: boolean;
  isUnSelectValid: boolean;
  onApply: () => void;
  onUnselectAll: () => void;
}

export const SortFilterFooter = ({
  isApplyValid,
  isUnSelectValid,
  onApply,
  onUnselectAll,
}: Props) => (
  <>
    <Separator />

    <Box as="section" display="flex" alignItems="center" p="16" flexShrink={0}>
      <Button variant="link" disabled={!isUnSelectValid} onClick={onUnselectAll} mr="auto">
        Unselect All
      </Button>

      <Button disabled={!isApplyValid} onClick={onApply}>
        Apply
      </Button>
    </Box>
  </>
);
